import { OneOrManySchema, SortModelSchemaFor } from 'notable-common';
import { z } from 'zod';
import { FlowAnyBlockTypeSchema } from './anyBlockType.js';
import { BlockCategory, BlockCustomIconVariant, BlockLifeCycle, BlockSafetyLevel, } from './attributes.js';
/** What the block catalog knows about one block type, minus the row's own identity columns. */
export const BaseBlockTypeMetadataSchema = z.object({
    blockType: FlowAnyBlockTypeSchema,
    name: z.string(),
    description: z.string(),
    blockCategory: z.enum(BlockCategory),
    blockSafetyLevel: z.enum(BlockSafetyLevel),
    blockLifeCycle: z.enum(BlockLifeCycle),
    blockLifeCyclePriority: z.number().int(),
    customIconVariant: z.enum(BlockCustomIconVariant).nullish(),
    searchKeywords: z.array(z.string()).nullish(),
});
export const BlockTypeMetadataFindAllOptionsSchema = z.object({
    q: z.string().optional(),
    blockCategory: OneOrManySchema(z.enum(BlockCategory)).optional(),
    blockSafetyLevel: OneOrManySchema(z.enum(BlockSafetyLevel)).optional(),
    blockLifeCycle: OneOrManySchema(z.enum(BlockLifeCycle)).optional(),
    sortModel: SortModelSchemaFor(z.enum(['name', 'blockCategory', 'blockSafetyLevel', 'blockLifeCyclePriority'])).optional(),
    limit: z.coerce.number().int().positive().max(1000).optional(),
    offset: z.coerce.number().int().nonnegative().optional(),
});
// The safety columns are absent on purpose: they gate test preflight, so edits go through migrations.
export const UpdateBlockTypeMetadataSchema = z.object({
    description: z.string().trim().min(10).optional(),
    blockCategory: z.enum(BlockCategory).optional(),
    blockLifeCycle: z.enum(BlockLifeCycle).optional(),
    customIconVariant: z.enum(BlockCustomIconVariant).nullish(),
    searchKeywords: z.array(z.string().trim().min(1)).min(1).nullish(),
});
//# sourceMappingURL=typeMetadata.js.map